<template>
  <div class="w-100 mt-5">
    <div class="alert alert-warning" role="alert" v-show="showAlert">
      {{showMessage}}
    </div>
    <div class="row">
      <div v-if="this.url === 'edit-category'" class="text-start p-3 m-2">
        <div class="row">
          <div class="alert alert-warning" role="alert">
            Your edit will affect all products that are within this Category/Sub Category
          </div>
        </div>
      </div>
      <div class="card text-start p-3 m-2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 fw-bold">
            Category
          </div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 fw-bold">
            Sub Category
          </div>
        </div>
        <div class="row">
          <table class="table" id="myTable">
            <tbody>
              <tr v-for="(cat, index) in sub_category" :key="index">
                <td v-if="!index">
                  <input type="text" class="form-control fw-bold" v-model="category" placeholder="Category" maxlength="32"/>
                </td>
                <td v-else></td>
                <td>
                  <div class="input-group">
                    <input type="text" class="form-control fw-bold w-75"
                      style="color: #5e50a1;" :style="index && url != 'edit-category' ? {borderRight: '0px !important'} : {}" v-model="cat.name"
                      :placeholder="'Sub Category '+ (index + 1)" maxlength="32"/>
                    <button v-if="index && url != 'edit-category'" class="input-group-text" id="basic-addon2"
                      style="background-color: white; border-left: 0px !important" @click="deleteRow(cat, index)"
                      >
                      <font-awesome-icon icon="fa-solid fa-xmark" class="text-danger fw-bold" />
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <button class="btn bg-white fw-bold" style="color: #5e50a1" @click="addRow">
                    <font-awesome-icon icon="fa-solid fa-plus" class="mr-1" />
                    Add Sub Category
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
    <div class="mt-1 d-flex justify-content-start">
      <button type="button" class="btn btn-danger text-white shadow-sm rounded" @click="submit" :disabled="category==''">Update
        Category</button>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    created() {
      var currentUrl = this.$route.path.split("/");
      this.id = currentUrl[currentUrl.length - 1]
      this.url = currentUrl[currentUrl.length - 2]
      console.log("URL : ", this.url)
    },
    data() {
      return {
        category: "",
        sub_category: [{
          id: null,
          name: null,
        }],
        id: "",
        url: "",
        showMessage: "",
        showAlert: false,
        disabled : false
      };
    },
    methods: {
      addRow() {
        this.sub_category.push({
          id: null,
          name: null,
        })
      },
      deleteRow(cat, index) {
        let filtered = [...this.sub_category]
        if(cat?.id){
          filtered = filtered.filter(x=> x.id !== cat.id)
        }else{
          filtered.splice(index, 1)
        }

        this.sub_category = filtered
      },
      async submit() {
        try {
          const maxCharErrorSub = this.sub_category.find(x => {
              return x.length > 32
            })

          if (this.category == ""){
            this.showMessage = "Category is Empty"
            this.showAlert = true

            setTimeout(() => {
              this.showAlert = false
            }, 3000);
            return
          }
          
          if (this.category.length > 32 || maxCharErrorSub) {
            this.showMessage = "Length Character more than 32"
            this.showAlert = true

            setTimeout(() => {
              this.showAlert = false
            }, 3000);
            return
          }

          let child = this.sub_category.map((item) => {
            return {
              "id": item?.id,
              "name": item.name,
              "level": 2,
              "description": ""
            }
          })

          let payload = {
            "parent": {
              "name": this.category,
              "level": 1,
              "description": ""
            },
            "child": child
          }

          if (this.url == "edit-category") {
            payload.parent.id = this.id
            await this.$store.dispatch("product/updateCategoryProduct", payload)
          } else {
            await this.$store.dispatch("product/createCategoryProduct", payload)
          }

          this.$router.push("/products/category-product");

        } catch (error) {
          this.$swal({
            title: error.response?.data?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }
      },
      async getOne() {
        let dataParent = []
        try {
          this.$store.dispatch("setLoadingGlobal", true)
          let data = await this.$store.dispatch("product/getDetailCategoryProduct", this.id)
          let id = data.level == 2 ? data.parent_category_id : this.id

          if (data.level == 2) {
            dataParent = await this.$store.dispatch("product/getDetailCategoryProduct", data.parent_category_id)
          }

          await this.$store.dispatch("product/getAllCategoryProduct", {
            level: 2,
            size: 9999
          })

          let childFunct = this.$store.getters['product/childProductItems']
          let childs = childFunct(id)

          this.category = data.level == 2 ? dataParent.name : data.name
          if (childs.length > 0) {
            this.sub_category = childs.map((item) => {
              return {name: item.name, id: item.id}
            })
          }

        } catch (error) {
          this.$swal({
            title: error.response?.data?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }finally{
          this.$store.dispatch("setLoadingGlobal", false)
        }
      }
    },
    mounted() {
      if (this.url == "edit-category") {
        this.getOne()
      }
    },
  };
</script>

<style></style>